import { connect } from 'react-redux';
import View from './ExpectedAnnualHomeownerInsuranceView';
import { currentClientId } from '../../../AdvWorkflow/AdvWorkflowSelector';
import { updateData } from '../../../AdvWorkflow/AdvWorkflowActions';
import nullableAnnualHomeownersInsuranceSelector from './ExpectedAnnualHomeownerInsuranceSelector';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../HomePurchaseWorkflowConstants';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  nullableAnnualHomeownersInsurance: nullableAnnualHomeownersInsuranceSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  onExpectedAnnualHomeownerInsuranceChanged: workflowId => ({ target: { value } }) => {
    let HomeInsurancePerYear = null;
    if (value !== '') {
      HomeInsurancePerYear = +value;
    }
    dispatch(updateData(
      {
        [HOME_PURCHASE_GOAL_GRAPH_NODE]: {
          HomeInsurancePerYear,
        },
      },
      workflowId,
    ));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
